import React from 'react';
import Banner from './Banner';
import Hero from './Hero';
import Expertise from './Expertise';
import { Container, Typography, Box, Grid, Card, useTheme, useMediaQuery, Zoom, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { themeColors } from '../App';
// Import client logos
// import AAL from '../assets/client/AAL.jpg';
// import ARMORED from '../assets/client/ARMORED VECHICLE NIGAL LIMITED.png';
// import AWEIL from '../assets/client/AWEIL.png';
// import HVF from '../assets/client/Heavy Vehicle Factory, Avadi.png';
// import HAL from '../assets/client/HAL.jpg';
// import INDIA_OPTEL from '../assets/client/INDIA OPTEL LIMITED.png';
// import RIVER from '../assets/client/RIVER Engineering Pvt Ltd.png';
// import LT from '../assets/client/l and t defence.png';
// import ESCORTS from '../assets/client/escorts railway equiement division.png';
// import OFT from '../assets/client/ordanance factory tiruchirapalli.png';
import navy from "../assets/client/new/Indian_navy.jpeg";
import air from "../assets/client/new/Indian_air_force.jpeg";
import army from "../assets/client/new/Indian_Army.jpeg";
import railway from "../assets/client/new/Indian_railway.jpeg";
import ordance from "../assets/client/new/Indian_ordinance.jpeg";
import drdo from "../assets/client/new/drdo.jpeg";
const Home = () => {
  return (
    <>
      <Banner />
      <Hero />
     
      <Expertise />
      
      {/* Our Clients Section */}
      <Box 
        sx={{ 
          py: 12,
          background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 50%, #ffffff 100%)',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '100%',
            background: 'radial-gradient(circle at 0% 0%, rgba(26, 71, 42, 0.05) 0%, transparent 50%), radial-gradient(circle at 100% 100%, rgba(76, 175, 80, 0.05) 0%, transparent 50%)',
            zIndex: 1
          }
        }}
      >
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 10 }}>
            <Typography 
              variant="overline" 
              sx={{ 
                color: themeColors.primary,
                fontWeight: 600,
                letterSpacing: 2,
                mb: 2,
                display: 'block',
                background: 'linear-gradient(45deg, #1a472a 20%, #4caf50 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                textShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}
            >
              TRUSTED BY INDUSTRY GIANTS
            </Typography>
            <Typography 
              variant="h3" 
              sx={{ 
                fontWeight: 800,
                mb: 3,
                background: 'linear-gradient(135deg, #1a472a 0%, #2e7d32 50%, #4caf50 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                textShadow: '0 2px 4px rgba(0,0,0,0.1)',
                letterSpacing: '0.5px'
              }}
            >
              Empowering India's Defense & Aerospace
            </Typography>
            <Typography 
              variant="h6" 
              sx={{ 
                color: 'text.secondary',
                maxWidth: '800px',
                mx: 'auto',
                lineHeight: 1.8,
                mb: 4,
                fontSize: '1.1rem'
              }}
            >
              For over 4 years, we've been a trusted partner to India's leading defense and aerospace organizations, 
              delivering precision-engineered solutions that meet the highest standards of quality and reliability.
            </Typography>
            <Grid container spacing={3} justifyContent="center" sx={{ mb: 6 }}>
              {[
                { number: '4+', label: 'Years of Excellence' },
                { number: '50+', label: 'Defense Projects' },
                { number: '20', label: 'Major Partnerships' }
              ].map((stat, index) => (
                <Grid item xs={12} sm={4} key={index}>
                  <Box
                    sx={{
                      p: 2,
                      background: 'linear-gradient(135deg, rgba(26, 71, 42, 0.03) 0%, rgba(76, 175, 80, 0.03) 100%)',
                      borderRadius: '12px',
                      backdropFilter: 'blur(8px)',
                      border: '1px solid rgba(255, 255, 255, 0.1)'
                    }}
                  >
                    <Typography 
                      variant="h4" 
                      sx={{ 
                        fontWeight: 700,
                        mb: 1,
                        background: 'linear-gradient(45deg, #1a472a 30%, #4caf50 90%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent'
                      }}
                    >
                      {stat.number}
                    </Typography>
                    <Typography 
                      variant="body1"
                      sx={{ 
                        color: 'text.secondary',
                        fontWeight: 500
                      }}
                    >
                      {stat.label}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>

          <Grid 
            container 
            spacing={4} 
            alignItems="center" 
            justifyContent="center"
            sx={{
              position: 'relative',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '100%',
                height: '100%',
                border: '2px dashed rgba(26, 71, 42, 0.1)',
                borderRadius: '20px',
                animation: 'rotate 60s linear infinite'
              },
              '@keyframes rotate': {
                '0%': { transform: 'translate(-50%, -50%) rotate(0deg)' },
                '100%': { transform: 'translate(-50%, -50%) rotate(360deg)' }
              }
            }}
          >
            {[
              { name: 'DRDO', logo: drdo },
              { name: 'Indian Army', logo: army },
              { name: 'Indian Navy', logo: navy },
              { name: 'Indian Ordnance', logo: ordance },
              { name: 'Indian Railways', logo: railway },
              { name: 'Indian Air Force', logo: air },
             
            ].map((client, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Zoom in={true} style={{ transitionDelay: `${index * 200}ms` }}>
                  <Card
                    sx={{
                      p: 4,
                      height: '220px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: 'rgba(255, 255, 255, 0.9)',
                      backdropFilter: 'blur(10px)',
                      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                      cursor: 'pointer',
                      position: 'relative',
                      overflow: 'hidden',
                      borderRadius: '16px',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      transform: 'translateY(-8px)',
                      boxShadow: '0 20px 40px rgba(0,0,0,0.12)',
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'linear-gradient(135deg, rgba(26, 71, 42, 0.05) 0%, rgba(76, 175, 80, 0.05) 100%)',
                        opacity: 1
                      }
                    }}
                  >
                    <Box
                      component="img"
                      src={client.logo}
                      alt={client.name}
                      sx={{
                        maxWidth: '85%',
                        maxHeight: '85%',
                        objectFit: 'contain',
                        transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                        filter: 'grayscale(0%) contrast(1.1)',
                        mb: 2
                      }}
                    />
                    <Typography
                      className="client-name"
                      variant="subtitle1"
                      sx={{
                        color: themeColors.primary,
                        fontWeight: 600,
                        opacity: 1,
                        transform: 'translateY(0)',
                        textAlign: 'center'
                      }}
                    >
                      {client.name}
                    </Typography>
                  </Card>
                </Zoom>
              </Grid>
            ))}
          </Grid>

          {/* Enhanced Decorative Elements */}
          <Box
            sx={{
              position: 'absolute',
              top: '10%',
              right: '5%',
              width: '300px',
              height: '300px',
              background: 'radial-gradient(circle, rgba(76, 175, 80, 0.03) 0%, rgba(255, 255, 255, 0) 70%)',
              borderRadius: '50%',
              animation: 'pulse 8s ease-in-out infinite',
              '@keyframes pulse': {
                '0%': { transform: 'scale(1) translate(0, 0)' },
                '50%': { transform: 'scale(1.2) translate(-20px, 20px)' },
                '100%': { transform: 'scale(1) translate(0, 0)' }
              }
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: '10%',
              left: '5%',
              width: '250px',
              height: '250px',
              background: 'radial-gradient(circle, rgba(26, 71, 42, 0.03) 0%, rgba(255, 255, 255, 0) 70%)',
              borderRadius: '50%',
              animation: 'pulse 8s ease-in-out infinite 1s',
            }}
          />

          <Box sx={{ textAlign: 'center', mt: 8, position: 'relative', zIndex: 3 }}>
            <Typography 
              variant="h5" 
              sx={{ 
                fontWeight: 600,
                mb: 3,
                background: 'linear-gradient(45deg, #1a472a 30%, #4caf50 90%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
            >
              Ready to Partner With Us?
            </Typography>
            <Typography 
              variant="body1" 
              sx={{ 
                color: 'text.secondary',
                maxWidth: '600px',
                mx: 'auto',
                mb: 4
              }}
            >
              Join India's leading defense organizations in experiencing our world-class manufacturing capabilities
            </Typography>
            <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center' }}>
              <Button
                component={Link}
                to="/contact"
                variant="contained"
                size="large"
                sx={{
                  background: 'linear-gradient(45deg, #1a472a 30%, #4caf50 90%)',
                  color: 'white',
                  px: 4,
                  py: 1.5,
                  borderRadius: '30px',
                  textTransform: 'none',
                  fontSize: '1.1rem',
                  fontWeight: 500,
                  boxShadow: '0 4px 12px rgba(76, 175, 80, 0.2)',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #15371f 30%, #3d8c40 90%)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 16px rgba(76, 175, 80, 0.3)',
                    textDecoration: 'none'
                  }
                }}
              >
                Contact Us Today
              </Button>
              <Button
                component={Link}
                to="/contact"
                variant="outlined"
                size="large"
                sx={{
                  color: '#1a472a',
                  borderColor: '#1a472a',
                  px: 4,
                  py: 1.5,
                  borderRadius: '30px',
                  textTransform: 'none',
                  fontSize: '1.1rem',
                  fontWeight: 500,
                  borderWidth: '2px',
                  '&:hover': {
                    borderColor: '#4caf50',
                    color: '#4caf50',
                    transform: 'translateY(-2px)',
                    borderWidth: '2px',
                    background: 'rgba(76, 175, 80, 0.04)',
                    textDecoration: 'none'
                  }
                }}
              >
                Request a Quote
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* Testimonials Section */}
      <Box 
        sx={{ 
          py: 12,
          background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'radial-gradient(circle at 0% 0%, rgba(26, 71, 42, 0.03) 0%, transparent 50%)',
            zIndex: 1
          }
        }}
      >
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography 
              variant="overline" 
              sx={{ 
                color: themeColors.primary,
                fontWeight: 600,
                letterSpacing: 2,
                mb: 2,
                display: 'block'
              }}
            >
              TESTIMONIALS
            </Typography>
            <Typography 
              variant="h3" 
              sx={{ 
                fontWeight: 800,
                mb: 3,
                background: 'linear-gradient(135deg, #1a472a 0%, #2e7d32 50%, #4caf50 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                textShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}
            >
              What Our Partners Say
            </Typography>
            <Typography 
              variant="h6" 
              sx={{ 
                color: 'text.secondary',
                maxWidth: '700px',
                mx: 'auto',
                mb: 8
              }}
            >
              Trusted by India's leading defense organizations for precision, quality, and reliability
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {[
              {
                name: "Col. Rajesh Kumar",
                position: "Senior Procurement Officer, DRDO",
                quote: "Vibhuti Industries has consistently delivered high-precision components that meet our stringent quality standards. Their commitment to excellence and adherence to timelines makes them a reliable partner for critical defense projects.",
                rating: 5
              },
              {
                name: "Dr. Priya Sharma",
                position: "Head of Quality Assurance, HAL",
                quote: "The technical expertise and manufacturing capabilities at Vibhuti Industries are truly impressive. They've been instrumental in helping us develop cutting-edge aerospace components with exceptional precision.",
                rating: 5
              },
              {
                name: "Mr. Suresh Patel",
                position: "Project Director, Larsen & Toubro",
                quote: "Working with Vibhuti Industries has been a game-changer for our defense manufacturing projects. Their attention to detail and innovative solutions have helped us achieve remarkable results.",
                rating: 5
              }
            ].map((testimonial, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Zoom in={true} style={{ transitionDelay: `${index * 200}ms` }}>
                  <Card
                    sx={{
                      p: 4,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      position: 'relative',
                      overflow: 'visible',
                      background: 'rgba(255, 255, 255, 0.9)',
                      backdropFilter: 'blur(10px)',
                      borderRadius: '20px',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-10px)',
                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                        '&::before': {
                          opacity: 1
                        }
                      },
                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        borderRadius: '20px',
                        background: 'linear-gradient(135deg, rgba(26, 71, 42, 0.05) 0%, rgba(76, 175, 80, 0.05) 100%)',
                        opacity: 0,
                        transition: 'opacity 0.3s ease'
                      }
                    }}
                  >
                    <Box 
                      sx={{ 
                        position: 'absolute',
                        top: -20,
                        left: 20,
                        color: themeColors.primary,
                        fontSize: '4rem',
                        opacity: 0.1,
                        fontFamily: 'Georgia, serif'
                      }}
                    >
                      "
                    </Box>
                    <Typography
                      variant="body1"
                      sx={{
                        mb: 4,
                        color: 'text.secondary',
                        lineHeight: 1.8,
                        fontStyle: 'italic',
                        position: 'relative',
                        flex: 1
                      }}
                    >
                      {testimonial.quote}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                      {Array.from({ length: testimonial.rating }).map((_, i) => (
                        <Box
                          key={i}
                          component="span"
                          sx={{
                            color: '#FFD700',
                            fontSize: '1.2rem'
                          }}
                        >
                          ★
                        </Box>
                      ))}
                    </Box>
                    <Box>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: 600,
                          color: themeColors.primary,
                          mb: 0.5
                        }}
                      >
                        {testimonial.name}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: 'text.secondary',
                          fontSize: '0.875rem'
                        }}
                      >
                        {testimonial.position}
                      </Typography>
                    </Box>
                  </Card>
                </Zoom>
              </Grid>
            ))}
          </Grid>

          <Box 
            sx={{ 
              position: 'absolute',
              bottom: -100,
              right: -100,
              width: '300px',
              height: '300px',
              background: 'radial-gradient(circle, rgba(76, 175, 80, 0.03) 0%, transparent 70%)',
              borderRadius: '50%',
              animation: 'pulse 8s ease-in-out infinite'
            }}
          />
        </Container>
      </Box>

    </>
  );
};

export default Home;
